import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { useUserState } from './Mode';
import { editBotInfo } from '../../data/dataApi';

const EditModal = ({
    show,
    changeVisibility,
    onUpdate,
    infoItem,
    onChange
}) => {
    const [error, setError] = useState();
    const [loading, setLoading] = useState(false);
    const { theme } = useUserState();

    const handleSaveInfo = async e => {
        e.preventDefault();
        
        if(!infoItem.content.trim()) {
            setError('Please type new content.');
        } else {
            setLoading(true);
            const response = await editBotInfo(infoItem);

            if(response.success) {
                const { content, type } = response.data.rows[0];

                onUpdate(prevState => prevState.map(info => {
                    if(info.id === infoItem.id) {
                        info.content = content;
                        info.type = type;
                    }

                    return info;
                }));

                changeVisibility(false);
            } else {
                setError(response.error.message);
            }
            setLoading(false);
        }
    };

    return (
        <Modal className={`edit-modal ${theme === 'light' ? 'light-mode' : ''}`} centered show={show} onHide={() => changeVisibility(false)}>
            <Modal.Body>
                <Form className="secondary-form" onSubmit={ handleSaveInfo }>
                    <Form.Group className="form-group tif-mb-20" controlId="formEditContent">
                        <Form.Label className='tif-color-hotel tif-light-color-oscar'>Edit Content:</Form.Label>
                        <Form.Control className="multiline border-0" as="textarea" value={infoItem.content} onChange={(e) => onChange(prevState => ({ ...prevState, content: e.target.value }))} />
                    </Form.Group>
                    { error && <p className="error-text tif-mb-5">{ error }</p> }
                    <Button type="submit" className='quarternary-btn tif-mt-115' disabled={ loading }>{ loading ? "Saving..." : "Save" }</Button>
                </Form>
            </Modal.Body>
        </Modal>
    );
};

export default EditModal;